import { useSelector } from 'react-redux';
import { formatBalanceUi } from '@utils/balance-helpers';
import { useTranslation } from 'react-i18next';

export default function MasterBalance() {
  const { masterBalance } = useSelector((state) => state.bankWallets);
  const { t } = useTranslation();
  return (
    <div className="master-balance">
      <p className="body-18m">{t('Master balance')}</p>
      <p
        className="title-h1r"
        dangerouslySetInnerHTML={{
          __html: formatBalanceUi(masterBalance, 'USD', null, true),
        }}
      />
    </div>
  );
}
